export default __webpack_public_path__ + "static/img-team-4-b4c6a490468eb92557aa776da22d000f.png";